import { Row, Button, Col } from "react-bootstrap";
import { RootState } from "redux/store";
import { useEffect, useRef, useState } from "react";
import { useDisplayError } from "helpers/Functions";
import { BulkEdit } from "./Popups/BulkEdit";
import { Spinner, Modal } from "components";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { updateAssignPriceGroupField, getPriceGroupsStore, bulkUpdatePriceGroupsStore, GetCurrentPriceGroup, applyPriceGroupsStore, updateAssignPriceGroupTableField, addAGGridSelectedStores } from "redux/slices/AssignPriceGroup";
import { AgGridReact } from "ag-grid-react";
import { getPriceGroupStoreConfig } from "TableConfigs/PriceGroupStoreConfig";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { AgGridToolbar } from "components/AgGrid/AgGridToolbar";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";

type storeProps = {
    updateTab: (tab: string) => void;
}

export default function StorePriceGroup({ updateTab }: storeProps) {
    const dispatch = useAppDispatch();
    const displayError = useDisplayError();
    const [saving, setSaving] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bulkEditShow, setBulkEditShow] = useState(false);
    const [disableModal, setDisableModal] = useState(false);
    const stores = useAppSelector((state: RootState) => state.stores);
    const priceGroups = useAppSelector((state: RootState) => state.priceGroups);
    const assignPriceGroup = useAppSelector((state: RootState) => state.assignPriceGroup);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const assignPriceGroupGridRef = useRef<AgGridReact>(null);

    function moveToDepartments(storeId: number) {
        updateTab("2");
        dispatch(updateAssignPriceGroupField({ key: "currentStore", value: storeId }));
        dispatch(updateAssignPriceGroupField({ key: "currentStorePriceGroup", value: GetCurrentPriceGroup(storeId) }));
    }

    useEffect(() => {        
        getStoresList();
    }, []);

    useEffect(() => {
        if (assignPriceGroup.activeTab === 1) getStoresList();
    }, [assignPriceGroup.activeTab, stores]);

    async function getStoresList() {
      //  assignPriceGroupGridRef.current?.api.showLoadingOverlay();
        const storeIds = stores.table.map((store: any) => store.id);
        if (storeIds.length > 0){

            await dispatch(getPriceGroupsStore({
                storeIds: storeIds,
                groupBy: "Stores"
            })).then(res =>{
                if(res.totalRows == 0){
                    assignPriceGroupGridRef.current?.api.showNoRowsOverlay()
                }
            });
        }
        else {
            dispatch(updateAssignPriceGroupField({key: "stores", value: []}));
        }  
    }
   
    async function bulkUpdatePriceGroups(storeIds: number[], priceGroupId: number) {
        await dispatch(bulkUpdatePriceGroupsStore({
            storeIds: storeIds,
            newPriceGroupId: priceGroupId
        })).then((res) => {
        }).catch((err: any) => {
            displayError(err);
        });
    }

    async function handleSubmit() {
        setDisableModal(true);
        setSaving(true);
        let storeIds: number[] = [];
        if (assignPriceGroup.selectedStores.length === 0) {
            storeIds = assignPriceGroup.stores.map((store: any) => store.storeId);
        } else {
            //@ts-ignore
            storeIds = assignPriceGroup.selectedStores.map((storeId: number) => assignPriceGroup.stores[storeId].storeId);
        }
        let payload: any = {
            filter: {
                storeIds: storeIds,
            },
            sync: true,
        };
        // console.log("payload", payload);
        await dispatch(applyPriceGroupsStore(payload)).then((res) => {
            setShowModal(false);
            setDisableModal(false);
            setSaving(false);

            if (res.data) {
                getStoresList()
            }
        });
    }

    async function saveBulkEdit(priceGroupId: number) {
        //@ts-ignore
        const storeIds = assignPriceGroup.selectedStores.map((storeId: number) => assignPriceGroup.stores[storeId].storeId);
        await bulkUpdatePriceGroups(storeIds, priceGroupId);
        await getStoresList();
        setBulkEditShow(false);
    }

    return (
        <>
           
                {bulkEditShow && <BulkEdit
                    show={bulkEditShow}
                    handleClose={() => setBulkEditShow(false)}
                    saveSelected={saveBulkEdit}
                    count={assignPriceGroup.selectedStores.length}
                />}
                <Modal
                    title="Confirm - Store level"
                    show={showModal}
                    buttonType="primary"
                    disableButtons={disableModal}
                    buttonText={disableModal ? "Applying..." : "Continue"}
                    handleClose={() => setShowModal(false)}
                    handleSubmit={handleSubmit}
                    description={
                        <>
                            <p>You are about to apply the new price group and sync the new sell prices.</p>
                            <p>Are you sure you want to continue?</p>
                        </>
                    }
                />
                <AgGridToolbar
                    search={true}
                    className="pb-1"
                    handleSubmit={(searchState, filterState) => {
                        assignPriceGroupGridRef.current?.api.clearRangeSelection();
                        dispatch(addAGGridSelectedStores([]));
                        assignPriceGroupGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);
                    }}
                    searchProps={
                        {totalRows: assignPriceGroup.stores.length, placeholder: "by Name", hideContains: true}
                    }
                    children={(
                        <div className="d-inline-flex gap-1">
                            { 
                            (assignPriceGroup.selectedStores != undefined && assignPriceGroup.selectedStores.length != 0) &&									
                                <Z.Button variant="light" className="h-100" disabled={true} buttonText={assignPriceGroup.selectedStores.length + " Selected"}/>
                            }
                            {assignPriceGroup.selectedStores.length > 1 &&
                                <Button variant="light" className="me-1" onClick={() => setBulkEditShow(true)}> <i className="mdi mdi-pencil"></i> Bulk Edit</Button>
                            }                    
                            <ZTooltip text="Refresh">
                                <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => getStoresList()} disabled={!user.permissions.priceGroups.canView} />
                            </ZTooltip>
                        </div>
                    )}
                />
           
                <Row>

                <AgGridReact
                    ref={assignPriceGroupGridRef}            
                    columnDefs={getPriceGroupStoreConfig(assignPriceGroup, user, priceGroups)}
                    rowData={ assignPriceGroup.stores != undefined && assignPriceGroup.stores.length != 0? assignPriceGroup.stores: null }
                    pagination={true}
                    paginationPageSize={20}
                    containerStyle={{ height: "74dvh" }}
                    className="ag-theme-quartz ag-theme-custom w-100"
                    rowSelection="multiple"
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    suppressContextMenu
                    onSelectionChanged={(e) => {
                        let formatedData:{
                            positon: number,
                            id: number
                        } [] = []
                        assignPriceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                        dispatch(addAGGridSelectedStores(formatedData));
                    }}
                    onRowSelected={() => {
                        let formatedData:{
                            positon: number,
                            id: number
                        } [] = []
                        assignPriceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                        dispatch(addAGGridSelectedStores(formatedData));
                    }}
                    components={{
                        baseCellRenderer: BaseCellRenderer,
                    }}
                    onCellClicked={(cell: any)=>{
                        if(cell.column.getColId() == "storeName"){
                        moveToDepartments(cell.data.storeId);
                        }
                    }}
                />
            </Row>
            <Row className="mt-3 mb-2">
                <Col sm={6}>
                </Col>
                <Col sm={6} className="d-flex flex-row-reverse">
                    <Button variant="primary" className="btn ms-1 cta-button" onClick={() => { setShowModal(true) }} disabled={!user.permissions.assignPriceGroups.canUpdate}>
                        {saving ? <Spinner className="spinner-border-sm me-1" tag="span" color="white" /> : null}
                        {saving ? "Applying..." : "Apply & Sync"}
                    </Button>
                    <Button variant="light" className="btn cta-button" onClick={() => dispatch(updateAssignPriceGroupField({ key: "activeTab", value: 3 }))}>Review Prices</Button>
                </Col>
            </Row>
        </>
    );
}